import {CheckboxWithLabel} from 'formik-material-ui'
import React, {Fragment} from 'react'
import {Grid, Grow, Typography} from '@material-ui/core'
import {Field} from 'formik'

import {DatePickerField} from '../../../../components/DatePickerField'
import {StepHeader} from '../../styles'

const Step5 = () => {
  return (
    <Fragment>
      <Grow mountOnEnter in timeout={500}>
        <StepHeader>
          <Typography
            variant="body1"
            gutterBottom
            color="textPrimary">
            Passo 2 de 3
          </Typography>
          <Typography
            variant="h5"
            gutterBottom
            color="textPrimary">
            Dados da empresa
          </Typography>
        </StepHeader>
      </Grow>
      <Grow mountOnEnter in timeout={900}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Field
              type="tel"
              fullWidth
              name="establishmentDate"
              component={DatePickerField}
              label="Qual a data de abertura"
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              Label={{ label: 'Mudança de sócios nos últimos 12 meses?' }}
              color="primary"
              label="Mudança de sócios nos últimos 12 meses?"
              name="partnerChanged"
              type="checkbox"
              component={CheckboxWithLabel}
            />
          </Grid>
        </Grid>
      </Grow>
    </Fragment>
  );
};

export default Step5;
